// PDF React View
import InputChips from "components/shared-components/InputChip/InputChips";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import { resetSendMailInvoicePos, sendMailInvoicePos } from "store/actions";
import {
  SEND_MAIL_INVOICE_POS_FAIL,
  SEND_MAIL_INVOICE_POS_SUCCESS,
} from "store/invoice-pos/actionTypes";
const SendMailModal = props => {
  const { isOpen, toggle, mailData, isInvoiceError } = props;

  const dispatch = useDispatch();
  const [listEmail, setListEmail] = useState([]);

  const invoicePos = useSelector(state => state.invoicePos);
  const { sendMailInvoiceData, type } = invoicePos;

  const { addToast } = useToasts();

  useEffect(() => {
    switch (type) {
      case SEND_MAIL_INVOICE_POS_SUCCESS:
        addToast("Gửi mail thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        if (isOpen) {
          toggle();
        }
        dispatch(resetSendMailInvoicePos());
        break;
      case SEND_MAIL_INVOICE_POS_FAIL:
        addToast("Gửi mail thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetSendMailInvoicePos());
        break;
      default:
        break;
    }
  }, [type]);

  useEffect(() => {
    if (isOpen) {
      if (mailData.mailDefault) {
        setListEmail([mailData.mailDefault]);
      }
    } else {
      setListEmail([]);
    }
  }, [isOpen]);

  const styleDiv = {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // background: "#8080802b",
  };

  const handleSelectMail = mails => {
    setListEmail(mails);
  };

  return (
    <Modal
      size="lg"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      // style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>Gửi mail</Label>
        </ModalHeader>
        <ModalBody>
          {sendMailInvoiceData.loading ? (
            <div style={styleDiv}>
              <Spinner color="primary" />
            </div>
          ) : (
            <InputChips
              defaultMails={listEmail}
              handleSelectMail={handleSelectMail}
            ></InputChips>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            color="success"
            className="me-2 btn-label"
            disabled={listEmail.length === 0 || sendMailInvoiceData.loading}
            onClick={() => {
              dispatch(
                sendMailInvoicePos(
                  mailData.idInvoice,
                  listEmail,
                  isInvoiceError
                )
              );
            }}
          >
            <i className="bx bx-mail-send label-icon" />
            Gửi
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

SendMailModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  mailData: PropTypes.object,
  isInvoiceError: PropTypes.bool,
};

export default SendMailModal;
